var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    clipPath: "url(#icon-copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6 8.006h4m-4 4h7m-7 4h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4V2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .506h20v20H0z"
  })))));
};
export { SvgIconCopy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xNSAyMEw0IDIwQzMuNDQ3NzIgMjAgMyAxOS41NTIzIDMgMTlMMyA1QzMgNC40NDc3MSAzLjQ0NzcyIDQgNCA0TDE1IDRDMTUuNTUyMyA0IDE2IDQuNDQ3NzIgMTYgNUwxNiAxOUMxNiAxOS41NTIzIDE1LjU1MjMgMjAgMTUgMjBaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTYgOC4wMDU4NkgxME02IDEyLjAwNTlIMTNNNiAxNi4wMDU5SDEyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNSA0TDUgMkM1IDEuNDQ3NzEgNS40NDc3MiAwLjk5OTk5OSA2IDAuOTk5OTk5TDE4IDFDMTguNTUyMyAxIDE5IDEuNDQ3NzIgMTkgMkwxOSAxN0MxOSAxNy41NTIzIDE4LjU1MjMgMTggMTggMThMMTYgMTgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUwNTg1OSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";